var Handlebars = require('C:/Users/sofdam/Work/direktupphandlingen-2019/node_modules/handlebars/runtime.js');
module.exports = (Handlebars['default'] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, helper;

  return "	"
    + ((stack1 = ((helper = (helper = helpers["no-result"] || (depth0 != null ? depth0["no-result"] : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"no-result","hash":{},"data":data}) : helper))) != null ? stack1 : "")
    + "\n";
},"3":function(container,depth0,helpers,partials,data) {
    var helper, alias1=container.escapeExpression;

  return "				<th id=\"table-header-row-"
    + alias1(((helper = (helper = helpers.index || (data && data.index)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"index","hash":{},"data":data}) : helper)))
    + "\" class=\"th-transparent\">\n					<p class=\"h-standfirst\">"
    + alias1(container.lambda(depth0, depth0))
    + "</p>\n				</th>\n";
},"5":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "			<tr>\n"
    + ((stack1 = helpers.each.call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.cols : depth0),{"name":"each","hash":{},"fn":container.program(6, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "			</tr>\n";
},"6":function(container,depth0,helpers,partials,data) {
    var helper, alias1=container.escapeExpression;

  return "					<td headers=\"table-header-row-"
    + alias1(((helper = (helper = helpers.index || (data && data.index)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"index","hash":{},"data":data}) : helper)))
    + "\">"
    + alias1(container.lambda(depth0, depth0))
    + "</td>\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.lambda, alias3=container.escapeExpression;

  return ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0["no-result"] : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "\n<table aria-label=\""
    + alias3(alias2(((stack1 = (depth0 != null ? depth0.table : depth0)) != null ? stack1.label : stack1), depth0))
    + "\" class=\"table-list\">\n	<caption class=\"is-visuallyhidden\">"
    + alias3(alias2(((stack1 = (depth0 != null ? depth0.table : depth0)) != null ? stack1.caption : stack1), depth0))
    + "</caption>\n	<thead>\n		<tr>\n"
    + ((stack1 = helpers.each.call(alias1,(depth0 != null ? depth0.columns : depth0),{"name":"each","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "		</tr>\n	</thead>\n	<tbody>\n"
    + ((stack1 = helpers.each.call(alias1,(depth0 != null ? depth0.rows : depth0),{"name":"each","hash":{},"fn":container.program(5, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "	</tbody>\n</table>\n";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./templates/table-list.hbs
// module id = 55
// module chunks = 9